import { gsap } from 'gsap'
import { PixiPlugin } from 'gsap/PixiPlugin'
import { signal } from 'services/SignalsService'
import { parallax } from 'settings/parallax'

gsap.registerPlugin(PixiPlugin)
PixiPlugin.registerPIXI(PIXI)

function dispatch(value) {
  signal.dispatch(`PARALLAX:${value}`)
}

export function enableParallax(container) {
  let settings = {
    ori: 'land',
    defaultData: { alpha: container.alpha, x: 0, pixi: { scaleY: 1 } },
  }

  signal.on('RESIZE', function ({ orientation }) {
    settings.ori = orientation
  })

  parallax[container.name].signalActivate.map((value) => signal.on(`${value}`, () => make('ACTIVATE')))
  parallax[container.name].signalRevert.map((value) => signal.on(`${value}`, () => make('REVERT')))

  function make(action) {
    switch (action) {
      case 'ACTIVATE': activate()
        break
      case 'REVERT': revert()
        break
    }
  }

  function activate() {
    const { x, alpha, pixi } = parallax[container.name][settings.ori]

    const obj = Object.entries({ x, alpha, pixi })
      .filter(([key]) => key)
      .reduce((acc, [key, value]) => {
        value || value == 0 ? acc[key] = value : delete acc[key]
        return acc
      }, {})

    gsap.to(
      container,
      parallax[container.name][settings.ori].duration,
      { ...obj, onComplete: () => dispatch('END') },
    )
  }

  function revert() {
    gsap.to(
      container,
      parallax[container.name][settings.ori].duration,
      { ...settings.defaultData, onComplete: () => dispatch('END') },
    )
  }
}
